import { ButtonLink } from '#components/router-links/button-link.js';
import { useDataElTagGenerator } from '#utils/use-data-el-tag-generator.js';

export function RouteAuthorizationErrorDisplay() {
	const el = useDataElTagGenerator(RouteAuthorizationErrorDisplay);
	return (
		<div {...el()} className='grid min-h-0 min-w-0 grow place-items-center p-4'>
			<div {...el('container')} className='flex flex-col gap-6'>
				<div className='flex min-w-0 grow basis-auto flex-col gap-3'>
					<h1 className='text-6xl font-bold text-gray-a9'>403</h1>
					<h2 className='text-3xl font-bold'>Access denied</h2>
					<p className='text-gray-a11'>You don&apos;t have permission to access this page.</p>
				</div>

				<ButtonLink to='/'>
					<span>Home</span>
				</ButtonLink>
			</div>
		</div>
	);
}
